import { render, staticRenderFns } from "./design_info.vue?vue&type=template&id=03320cd4&scoped=true"
import script from "./design_info.vue?vue&type=script&lang=js"
export * from "./design_info.vue?vue&type=script&lang=js"
import style0 from "./design_info.vue?vue&type=style&index=0&id=03320cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03320cd4",
  null
  
)

export default component.exports